import { MeilisearchAttribute, MeilisearchSortingDirection } from '../@api/Meilisearch';

export const sortParameter = 'sort';

export const inStockSort = `${MeilisearchAttribute.inStock}:${MeilisearchSortingDirection.descending}`;
